import React from 'react';

export const EmptyList = (props) => (
  <div className="flex h-24 items-center justify-center rounded-lg bg-gray-100">
    <h2 className="text-gray-700">{props.text}</h2>
  </div>
);